import React from 'react';
import PortalLogin from '@/components/PortalLogin';

// Total-E Management login. Uses the shared PortalLogin template so the upcoming
// Client, TEAM and Partners screens match its layout, spacing and controls.
const Login = () => <PortalLogin portal="management" />;

export default Login;
